import { jsxs as S, jsx as t, Fragment as X } from "react/jsx-runtime";
import K, { useContext as ie, useEffect as O, useRef as q, useState as U, useCallback as ce, useMemo as Y } from "react";
import { u as B } from "./uniqueId-321287e8.mjs";
import { Checkbox as re, CheckboxStateValues as H } from "./checkbox.js";
import { u as D, a as ee } from "./index-6a632112.mjs";
import { Accordion as de, AccordionItemOld as se, AccordionPanel as me } from "./accordion.js";
import { Q as W } from "./themes-5f0b3c3d.mjs";
import { TableContext as te } from "./table.js";
import { a as I, b as be } from "./tableContainer-cf101627.mjs";
import { S as F } from "./types-b577bf77.mjs";
import { c as k } from "./index-98c703e1.mjs";
import { Button as he } from "./button.js";
import { FilterGroup as ue, Filter as pe } from "./filter.js";
import { Pagination as fe } from "./pagination.js";
import { SingleSelectInput as Te } from "./selectInput.js";
import { debounce as ge } from "./debounce.js";
import { TextInput as Ce } from "./textInput.js";
import { S as ve } from "./index-39f84169.mjs";
function $e({
  title: e,
  titleId: l,
  size: o,
  height: h,
  width: w,
  ...p
}) {
  const i = o ? F[o] : F.s;
  return /* @__PURE__ */ S(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      height: o ? i : h || i,
      width: o ? i : w || i,
      "aria-labelledby": l,
      ...p,
      children: [
        e ? /* @__PURE__ */ t("title", { id: l, children: e }) : null,
        /* @__PURE__ */ t("g", { clipPath: "url(#Arrow__Down_svg__a)", children: /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M13.5 15.755 35.998 56.25 58.5 15.75l-45 .005Z",
            clipRule: "evenodd"
          }
        ) }),
        /* @__PURE__ */ t("defs", { children: /* @__PURE__ */ t("clipPath", { id: "Arrow__Down_svg__a", children: /* @__PURE__ */ t("path", { fill: "currentColor", d: "M0 0h72v72H0z" }) }) })
      ]
    }
  );
}
function we({
  title: e,
  titleId: l,
  size: o,
  height: h,
  width: w,
  ...p
}) {
  const i = o ? F[o] : F.s;
  return /* @__PURE__ */ S(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      height: o ? i : h || i,
      width: o ? i : w || i,
      "aria-labelledby": l,
      ...p,
      children: [
        e ? /* @__PURE__ */ t("title", { id: l, children: e }) : null,
        /* @__PURE__ */ t("g", { clipPath: "url(#Arrow__up_svg__a)", children: /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "m36 14.25-22.5 43.5h45l-22.495-43.5H36Z",
            clipRule: "evenodd"
          }
        ) }),
        /* @__PURE__ */ t("defs", { children: /* @__PURE__ */ t("clipPath", { id: "Arrow__up_svg__a", children: /* @__PURE__ */ t("path", { fill: "currentColor", d: "M0 0h72v72H0z" }) }) })
      ]
    }
  );
}
function Pe({
  title: e,
  titleId: l,
  size: o,
  height: h,
  width: w,
  ...p
}) {
  const i = o ? F[o] : F.s;
  return /* @__PURE__ */ S(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      height: o ? i : h || i,
      width: o ? i : w || i,
      "aria-labelledby": l,
      ...p,
      children: [
        e ? /* @__PURE__ */ t("title", { id: l, children: e }) : null,
        /* @__PURE__ */ t("g", { clipPath: "url(#Clear_svg__a)", children: /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            fillRule: "evenodd",
            d: "M61.2 36c0 13.86-11.34 25.2-25.2 25.2S10.8 49.86 10.8 36 22.14 10.8 36 10.8 61.2 22.14 61.2 36ZM36 14.4c-11.88 0-21.6 9.72-21.6 21.6S24.12 57.6 36 57.6 57.6 47.88 57.6 36 47.88 14.4 36 14.4Zm8.28 10.8 2.52 2.52L38.52 36l8.28 8.28-2.52 2.52L36 38.52l-8.28 8.28-2.52-2.52L33.48 36l-8.28-8.28 2.52-2.52L36 33.48l8.28-8.28Z",
            clipRule: "evenodd"
          }
        ) }),
        /* @__PURE__ */ t("defs", { children: /* @__PURE__ */ t("clipPath", { id: "Clear_svg__a", children: /* @__PURE__ */ t("path", { fill: "currentColor", d: "M0 0h72v72H0z" }) }) })
      ]
    }
  );
}
function Ae({
  title: e,
  titleId: l,
  size: o,
  height: h,
  width: w,
  ...p
}) {
  const i = o ? F[o] : F.s;
  return /* @__PURE__ */ S(
    "svg",
    {
      xmlns: "http://www.w3.org/2000/svg",
      fill: "none",
      viewBox: "0 0 72 72",
      height: o ? i : h || i,
      width: o ? i : w || i,
      "aria-labelledby": l,
      ...p,
      children: [
        e ? /* @__PURE__ */ t("title", { id: l, children: e }) : null,
        /* @__PURE__ */ t("g", { clipPath: "url(#Sorting_svg__a)", children: /* @__PURE__ */ t(
          "path",
          {
            fill: "currentColor",
            d: "M54.583 28.8H17.417c-.713 0-1.07-.87-.565-1.379l16.886-17.058a3.176 3.176 0 0 1 4.523 0L55.149 27.42c.504.51.147 1.379-.566 1.379ZM16.852 44.579l16.887 17.058a3.176 3.176 0 0 0 4.524 0L55.149 44.58c.504-.51.147-1.379-.566-1.379H17.417c-.713 0-1.07.87-.565 1.379Z"
          }
        ) }),
        /* @__PURE__ */ t("defs", { children: /* @__PURE__ */ t("clipPath", { id: "Sorting_svg__a", children: /* @__PURE__ */ t("path", { fill: "currentColor", d: "M0 0h72v72H0z" }) }) })
      ]
    }
  );
}
const De = D(de)`
  ${(e) => `
 border-radius: ${e.theme.components.dataTable.TableAccordionData.borderRadius};
 && > div {
    align-items: ${e.theme.components.dataTable.TableAccordionData.div.alignItems};
    width: ${e.theme.components.dataTable.TableAccordionData.div.width};
    border-top: ${e.theme.components.dataTable.TableAccordionData.div.borderTop};
    border-bottom: ${e.theme.components.dataTable.TableAccordionData.div.borderBottom};
    border-radius: ${e.theme.components.dataTable.TableAccordionData.div.borderRadius};
 }
  @media ${W.tabletAndUp} {
    display: ${e.theme.components.dataTable.TableAccordionData.div.tabletView.display};
  }
  border-top: ${e.theme.components.dataTable.TableAccordionData.borderTop};
  border-bottom: ${e.theme.components.dataTable.TableAccordionData.borderBottom};
    `}
`, xe = D(se)`
  ${(e) => `
    background: ${e.$background ? e.theme.components.dataTable.TableAccordionItemData.backgroundColor.isBackground : e.theme.components.dataTable.TableAccordionItemData.backgroundColor.none};
    border-radius: ${e.theme.components.dataTable.TableAccordionItemData.borderRadius};
    padding: ${e.theme.components.dataTable.TableAccordionItemData.padding};
    && > div {
      padding-left: ${e.theme.components.dataTable.TableAccordionItemData["&& > div"].paddingLeft};
    }
    [data-component='accordion-dropdown-wrapper'] {
      color: ${e.theme.components.dataTable.TableAccordionItemData['[data-component="accordion-dropdown-wrapper"]'].color};
    }
    [data-component='accordion-title-wrapper'] {
      height: ${e.theme.components.dataTable.TableAccordionItemData['[data-component="accordion-title-wrapper"]'].height};
      font-family: ${e.theme.components.dataTable.TableAccordionItemData['[data-component="accordion-title-wrapper"]'].fontFamily};
      font-size: ${e.theme.components.dataTable.TableAccordionItemData['[data-component="accordion-title-wrapper"]'].fontSize};
      font-style: ${e.theme.components.dataTable.TableAccordionItemData['[data-component="accordion-title-wrapper"]'].fontStyle};
      font-weight: ${e.theme.components.dataTable.TableAccordionItemData['[data-component="accordion-title-wrapper"]'].fontWeight};
      line-height: ${e.theme.components.dataTable.TableAccordionItemData['[data-component="accordion-title-wrapper"]'].lineHeight};
    }
    ${e.$showcheckboxenabled ? `[data-component="accordion-icon-wrapper"]{

          }
        ` : ""}
    `}
`, ye = D.div`
  ${(e) => `
    display: ${e.theme.components.dataTable.TableAccordionPanelContent.TableAccordionPanelContentContainer.display};;
    flex-direction: ${e.theme.components.dataTable.TableAccordionPanelContent.TableAccordionPanelContentContainer.flexDirection};
    align-items: ${e.theme.components.dataTable.TableAccordionPanelContent.TableAccordionPanelContentContainer.alignItems};
    gap: ${e.theme.components.dataTable.TableAccordionPanelContent.TableAccordionPanelContentContainer.gap};
    align-self: ${e.theme.components.dataTable.TableAccordionPanelContent.TableAccordionPanelContentContainer.alignSelf};
    `}
`, G = D.div`
  ${(e) => `
    display: ${e.theme.components.dataTable.TableAccordionPanelContent.TableAccordionPanelContentData.display};
    flex-direction: ${e.theme.components.dataTable.TableAccordionPanelContent.TableAccordionPanelContentData.flexDirection};
    align-items: ${e.theme.components.dataTable.TableAccordionPanelContent.TableAccordionPanelContentData.alignItems};
    gap: ${e.theme.components.dataTable.TableAccordionPanelContent.TableAccordionPanelContentData.gap};
    div {
      gap: ${e.theme.components.dataTable.TableAccordionPanelContent.TableAccordionPanelContentData.div.gap};
      align-items: ${e.theme.components.dataTable.TableAccordionPanelContent.TableAccordionPanelContentData.div.alignItems};
    }
    align-self: ${e.theme.components.dataTable.TableAccordionPanelContent.TableAccordionPanelContentData.alignSelf};
    `}
`, Se = D(me)`
  ${(e) => `
    width: ${e.theme.components.dataTable.TableAccordionPanelData.width};
    height: ${e.theme.components.dataTable.TableAccordionPanelData.height};
    justify-content: ${e.theme.components.dataTable.TableAccordionPanelData.justifyContent};
    margin: ${e.theme.components.dataTable.TableAccordionPanelData.margin};
    padding: ${e.theme.components.dataTable.TableAccordionPanelData.padding};
    && > div {
      color: ${e.theme.components.dataTable.TableAccordionPanelData["&& > div"].color};
      font-family: ${e.theme.components.dataTable.TableAccordionPanelData["&& > div"].fontFamily};
      font-size: ${e.theme.components.dataTable.TableAccordionPanelData["&& > div"].fontSize};
      letter-spacing: ${e.theme.components.dataTable.TableAccordionPanelData["&& > div"].letterSpacing};
      line-height: ${e.theme.components.dataTable.TableAccordionPanelData["&& > div"].lineHeight};
    }
    `}
`, Ee = ({
  content: e,
  title: l,
  rowElementIndex: o,
  id: h,
  backgroundColor: w,
  DropDownComponent: p,
  $checkboxProps: i
}) => {
  const {
    checkboxCheckedValues: L,
    setCheckboxChecked: u,
    showOptionsEnabled: b,
    showCheckboxEnabled: V
  } = K.useContext(te), x = L?.find(
    (n) => n.id === h
  );
  return /* @__PURE__ */ t(De, { "data-component": "accordion-data", children: /* @__PURE__ */ t(
    xe,
    {
      title: l,
      id: `${o}`,
      $showcheckboxenabled: V,
      $background: w,
      isIconOnClickEnabled: !1,
      isDropDownMenu: b,
      DropDownComponent: p,
      isAnimate: !1,
      icon: V && /* @__PURE__ */ t(
        re,
        {
          checkboxValue: i?.value || x?.value,
          onChange: (n) => {
            u && u(
              h,
              (x?.value === H.UNCHECKED || x?.value === void 0) && H.CHECKED || H.UNCHECKED
            ), i && i.onClick && i.onClick(
              n,
              h,
              (x?.value === H.UNCHECKED || x?.value === void 0) && H.CHECKED || H.UNCHECKED
            );
          },
          isDisabled: i?.disabled || x?.disabled
        }
      ) || "",
      children: /* @__PURE__ */ t(
        Se,
        {
          content: /* @__PURE__ */ t(ye, { children: e })
        }
      )
    }
  ) });
}, Q = D.div`
  ${(e) => `
    color: ${e.theme.components.dataTable.TableAccordionPanelContentColumnData.color};
    font-family: ${e.theme.components.dataTable.TableAccordionPanelContentColumnData.fontFamily};
    font-size: ${e.theme.components.dataTable.TableAccordionPanelContentColumnData.fontSize};
    font-style: ${e.theme.components.dataTable.TableAccordionPanelContentColumnData.fontStyle};
    font-weight: ${e.theme.components.dataTable.TableAccordionPanelContentColumnData.fontWeight};
    line-height: ${e.theme.components.dataTable.TableAccordionPanelContentColumnData.lineHeight};

    `}
`, J = D.div`
  ${(e) => `
    :only-child:not(button) {
      color: ${e.theme.components.dataTable.TableAccordionPanelContentTableData.color};
      font-family: ${e.theme.components.dataTable.TableAccordionPanelContentTableData.fontFamily};
      font-size: ${e.theme.components.dataTable.TableAccordionPanelContentTableData.fontSize};
      font-style: ${e.theme.components.dataTable.TableAccordionPanelContentTableData.fontStyle};
      font-weight: ${e.theme.components.dataTable.TableAccordionPanelContentTableData.fontWeight};
      line-height: ${e.theme.components.dataTable.TableAccordionPanelContentTableData.lineHeight};
    }
    `}
`, Le = D.button`
  ${(e) => `
    border-color: ${e.theme.components.dataTable.TableSortingView.Wrapper.borderColor};
    background-color: ${e.theme.components.dataTable.TableSortingView.Wrapper.backgroundColor};
    color: ${e.theme.components.dataTable.TableSortingView.Wrapper.color};
    `}
`, Ve = ({
  rowValues: e,
  setRowValues: l,
  columnNumber: o,
  onClick: h,
  setSortingEnabled: w
}) => {
  const { sortOrder: p, setSortOrder: i } = ie(te);
  O(() => {
    w(!0);
  }, []);
  const L = () => {
    const u = {
      columnNumber: o,
      value: p?.value === "asc" ? "desc" : "asc"
    };
    i(u), l(e, u);
  };
  return /* @__PURE__ */ t(
    Le,
    {
      onClick: (u) => {
        u.preventDefault(), L(), h && h(u, p?.value === "asc" ? "desc" : "asc");
      },
      children: p.columnNumber === o && p?.value === "asc" && /* @__PURE__ */ t(we, { size: "s" }) || p.columnNumber === o && p?.value === "desc" && /* @__PURE__ */ t($e, { size: "s" }) || /* @__PURE__ */ t(Ae, { size: "s" })
    }
  );
}, Ie = D.div`
  &.TableEmptyView-wrapper {
    ${({
  theme: {
    components: { dataTable: e }
  }
}) => ee(e.TableEmptyViewWrapper)};
  }
`, _e = D.div`
  &.TableEmptyViewContainer-container {
    ${({
  theme: {
    components: { dataTable: e }
  }
}) => ee(e.TableEmptyViewContainer)};
  }
`, Fe = ({
  children: e,
  isMarketingTable: l = !1,
  isMobile: o
}) => /* @__PURE__ */ t(
  _e,
  {
    className: k(["TableEmptyViewContainer-container"]),
    children: /* @__PURE__ */ t(
      Ie,
      {
        className: k([
          "TableEmptyView-wrapper",
          { "TableEmptyView-wrapper--marketingTable": l },
          { "TableEmptyView-wrapper--mobile": o }
        ]),
        children: e
      }
    )
  }
), N = D.div`
  display: flex;
  align-items: center;

  @media ${W.tabletAndUp} {
    margin: auto 0;
    div:first-child {
      align-items: center;
    }
  }
`, Me = D.div`
  @media ${W.tabletAndUp} {
    display: flex;
    flex-direction: column;
  }
`, ct = ({
  headerValues: e,
  rowValues: l = [],
  headerCheckboxProps: o,
  setRowValues: h,
  emptyTableMessage: w,
  setSortingEnabled: p
}) => {
  const i = e.map((b, V) => /* @__PURE__ */ S(I.CellContent, { children: [
    b.leadingComponents,
    b.textValue && /* @__PURE__ */ t(I.CellContentText, { contentAlignment: b.contentAlignment, children: b.textValue }),
    b.trailingComponents
  ] }, V)), L = /* @__PURE__ */ t(
    be,
    {
      $checkboxProps: o,
      children: /* @__PURE__ */ S(
        I.Header,
        {
          style: {
            display: "flex",
            justifyContent: "space-between",
            width: "100%"
          },
          children: [
            /* @__PURE__ */ S(I.CellContent, { children: [
              e[0]?.leadingComponents,
              e[0]?.textValue && /* @__PURE__ */ t(
                I.CellContentText,
                {
                  contentAlignment: e[0]?.contentAlignment,
                  children: e[0]?.textValue
                }
              ),
              e[0]?.trailingComponents
            ] }),
            (e[0]?.isSortingEnabled || e[0]?.sortingProp?.isSortingEnabled) && /* @__PURE__ */ t(
              Ve,
              {
                setSortingEnabled: p,
                rowValues: l,
                setRowValues: (...b) => h(...b, e[0]?.sortingProp?.comparator),
                columnNumber: 0,
                onClick: e[0]?.sortingProp?.onClick
              }
            )
          ]
        }
      )
    },
    B("thead")
  ), u = [];
  return u.push(L), l.length > 0 ? l.forEach((b, V) => {
    let x, n;
    b.cellData.forEach((d, E) => {
      const P = /* @__PURE__ */ S(
        I.Cell,
        {
          contentAlignment: e[E].contentAlignment || "center",
          id: d.id,
          children: [
            d.leadingComponents && /* @__PURE__ */ t(N, { children: d.leadingComponents }),
            /* @__PURE__ */ S(Me, { children: [
              /* @__PURE__ */ S(I.CellContent, { children: [
                d.textValue && /* @__PURE__ */ t(
                  I.CellContentText,
                  {
                    contentAlignment: e[E].contentAlignment || "center",
                    children: d.textValue
                  }
                ),
                d.trailingComponents && !d.textValue && /* @__PURE__ */ t(N, { children: d.trailingComponents })
              ] }),
              d.description && /* @__PURE__ */ t(I.CellDescription, { children: d.description })
            ] }),
            d.trailingComponents && d.textValue && /* @__PURE__ */ t(N, { children: d.trailingComponents })
          ]
        },
        `${d.id || E}_0_${B("table_cell")}`
      );
      E === 0 ? x = P : K.isValidElement(n) ? n = /* @__PURE__ */ S(X, { children: [
        n,
        /* @__PURE__ */ S(
          G,
          {
            children: [
              /* @__PURE__ */ t(Q, { className: "label", children: i[E] }),
              /* @__PURE__ */ t(J, { children: P })
            ]
          },
          `${d.id || E}_0_${B("table_cell")}`
        )
      ] }) : n = /* @__PURE__ */ S(
        G,
        {
          children: [
            /* @__PURE__ */ t(Q, { className: "label", children: i[E] }),
            /* @__PURE__ */ t(J, { children: P })
          ]
        },
        `${d.id || E}_0_${B("table_cell")}`
      );
    }), u.push(
      /* @__PURE__ */ t(
        Ee,
        {
          content: n,
          title: x,
          rowElementIndex: V,
          id: b.rowId,
          $checkboxProps: b.checkboxProps,
          DropDownComponent: b.DropDownComponent
        }
      )
    );
  }) : u.push(
    /* @__PURE__ */ t(Fe, { isMobile: !0, children: w || "" })
  ), u;
}, He = D.span`
  display: flex;
  align-items: center;
  font-family: Inter;
  font-size: 14px;
  font-weight: 500;
  line-height: 20px;
  text-align: left;
`, rt = ({
  headerValues: e,
  rowValues: l,
  setRowValues: o,
  onClearAll: h,
  filterGroupLabel: w = "Filter by: ",
  clearAllLabel: p = "Clear all",
  setFilterEnabled: i,
  variant: L = "individual",
  sortFilterValues: u = "desc"
}) => {
  const b = q({}), [V, x] = U(!1), n = q({}), d = ce((s, c) => {
    !n.current[s] && L === "progressive" && (n.current = {
      ...n.current,
      [s]: { value: [c], selectedLevel: -1 }
    });
  }, []), E = (s, c) => {
    const C = [], r = [], a = /* @__PURE__ */ new Set(), f = [];
    return e.forEach((v, $) => {
      l.forEach((m) => {
        const T = m.cellData[$]?.id ?? "";
        c.find((A) => A.includes(T)) && f.push(m.rowId);
      });
    }), e.forEach((v, $) => {
      l.forEach((m) => {
        const T = v.filterProp?.label || v.textValue || "", g = m.cellData[$]?.textValue || "", A = m.cellData[$]?.id || "";
        if (f.includes(m.rowId) && T === s && !a.has(g))
          a.add(g), r.push({ label: g, value: A });
        else if (f.includes(m.rowId) && T === s && a.has(g)) {
          const M = r.find((z) => z.label === g);
          M ? M.value += `, ${A}` : r.push({ label: g, value: A });
        }
      });
    }), u === "asc" ? r.sort((v, $) => v.label.localeCompare($.label)) : r.sort((v, $) => $.label.localeCompare(v.label)), C.push({ items: r }), C;
  }, P = (s, c) => {
    let C = 0;
    Object.keys(n.current).forEach((a) => {
      C <= n.current[a].selectedLevel && (C = n.current[a].selectedLevel);
    });
    let r = C;
    Object.keys(n.current).forEach((a) => {
      a === s && n.current[a].selectedLevel < 0 && (r = r + 1, n.current[a] = {
        ...n.current[a],
        selectedLevel: r
      });
    }), Object.keys(n.current).forEach((a) => {
      if (a !== s && (n.current[a].selectedLevel >= r || n.current[a].selectedLevel < 0) && c.length) {
        const f = E(a, c);
        n.current[a] = {
          value: f,
          selectedLevel: n.current[a].selectedLevel
        };
      } else if (!c.length && a === s)
        delete n.current[a];
      else if (!c.length && a !== s && b.current[a]?.length) {
        const f = E(a, b.current[a]);
        n.current[s] = {
          value: f,
          selectedLevel: n.current[s]?.selectedLevel || -1
        };
        const v = e.findIndex(
          (g) => g.textValue === a
        ), $ = [], m = [], T = /* @__PURE__ */ new Set();
        l.forEach((g) => {
          const A = g.cellData[v]?.textValue || "", M = g.cellData[v]?.id || "";
          if (A && !T.has(A))
            T.add(A), m.push({ label: A, value: M });
          else if (A) {
            const z = m.find((le) => le.label === A);
            z ? z.value += `, ${M}` : m.push({ label: A, value: M });
          }
        }), u === "asc" ? m.sort((g, A) => g.label.localeCompare(A.label)) : m.sort((g, A) => A.label.localeCompare(g.label)), $.push({ items: m }), n.current[a] = {
          selectedLevel: n.current[a].selectedLevel,
          value: $
        };
      } else
        a !== s && (n.current[a].selectedLevel >= r || n.current[a].selectedLevel < 0) && !c.length && (n.current = {});
    });
  }, y = !!Object.keys(b.current).length, _ = Y(() => !!y, [y]);
  O(() => {
    i(_);
  }, [_]), O(() => {
    x(
      e.some((s) => s.filterProp?.isFilterEnabled)
    );
  }, [e]);
  const j = (s, c) => {
    const C = [], r = [], a = /* @__PURE__ */ new Set();
    l.forEach(($) => {
      const m = $.cellData[s]?.textValue || "", T = $.cellData[s]?.id || "";
      if (m && !a.has(m))
        a.add(m), r.push({ label: m, value: T });
      else if (m) {
        const g = r.find((A) => A.label === m);
        g ? g.value += `, ${T}` : r.push({ label: m, value: T });
      }
    }), u === "asc" ? r.sort(($, m) => $.label.localeCompare(m.label)) : r.sort(($, m) => m.label.localeCompare($.label)), C.push({ items: r }), d(c.filterProp?.label || c.textValue || "", {
      items: r
    });
    const f = b.current[c.filterProp?.label || c.textValue || ""] || [];
    return { newFilterMenuList: c.filterProp?.menuOptions || n.current[c.filterProp?.label || c.textValue || ""] && [
      ...n.current[c.filterProp?.label || c.textValue || ""].value
    ] || C, values: f };
  }, R = () => {
    const s = [];
    return e.forEach((c, C) => {
      if (c.filterProp?.isFilterEnabled) {
        const { newFilterMenuList: r, values: a } = j(C, c);
        s.push(
          /* @__PURE__ */ t(
            pe,
            {
              menuHeader: "local_search",
              menuLists: r,
              onChange: (f, v) => {
                f.preventDefault(), f.stopPropagation(), ae(f, v), c.filterProp?.onClick && c.filterProp?.onClick(f, v);
              },
              value: a,
              children: c.filterProp?.label || c.textValue || ""
            },
            c.id
          )
        );
      }
    }), s;
  }, Z = (s, c, C) => {
    s.cellData.find((r) => r.id === c) && !C.includes(s) && C.push(s);
  }, ne = () => {
    const s = [];
    return l.forEach((c) => {
      let C = !0;
      Object.entries(b.current).forEach(
        ([r, a]) => {
          if (a.length > 0) {
            const f = [];
            a.forEach((T) => {
              T.includes(",") ? T.split(",").forEach((g) => {
                f.push(g.trim());
              }) : f.push(T);
            });
            const v = e.findIndex(
              (T) => T.filterProp?.label === r || T.textValue === r
            ), $ = c.cellData[v]?.id || "", m = f.includes($);
            m && (n.current[r].selectedLevel === -1 || n.current[r].selectedLevel > -1 && n.current[r] && n.current[r].selectedLevel !== n.current[r].selectedLevel) && (C = !1), !m && n.current[r].selectedLevel > -1 && (C = !1);
          }
        }
      ), C && s.push(c);
    }), s;
  }, ae = (s, c) => {
    s.preventDefault();
    const C = c.label, r = [];
    c.values.forEach((v) => {
      r.push(v);
    });
    const a = {
      ...b.current,
      [C]: r
    };
    Object.keys(a).every(
      (v) => a[v].length === 0
    ) ? b.current = {} : b.current = a;
    let f = [];
    L === "progressive" ? (P(C, c.values), f = ne()) : Object.keys(a).forEach((v) => {
      const $ = [...a[v]];
      l.forEach((m) => {
        $.forEach((T) => {
          T.includes(",") ? T.split(",").forEach(
            (g) => Z(m, g.trim(), f)
          ) : Z(m, T, f);
        });
      });
    }), f.length ? o(f) : o(l);
  }, oe = (s) => {
    s.preventDefault(), h && h(s), o(l), n.current = {}, b.current = {};
  };
  return V && /* @__PURE__ */ S(ue, { children: [
    /* @__PURE__ */ t(He, { children: w }),
    R(),
    /* @__PURE__ */ t(he, { size: "small", variant: "text", onClick: oe, children: p })
  ] }) || /* @__PURE__ */ t(X, {});
}, Oe = D.div`
  ${(e) => `
    display: ${e.theme.components.dataTable.TablePaginationView.Wrapper.display};
    flex-direction: ${e.theme.components.dataTable.TablePaginationView.Wrapper.flexDirection};
    justify-content: ${e.theme.components.dataTable.TablePaginationView.Wrapper.justifyContent};
    gap: ${e.theme.components.dataTable.TablePaginationView.Wrapper.gap};
    @media ${W.tabletAndUp} {
      flex-direction: ${e.theme.components.dataTable.TablePaginationView.Wrapper.tabletView.flexDirection}
    `}
`, je = D.div`
  ${(e) => `
    display: ${e.theme.components.dataTable.TablePaginationView.Container.display};
    flex-direction: ${e.theme.components.dataTable.TablePaginationView.Container.flexDirection};
    justify-content: ${e.theme.components.dataTable.TablePaginationView.Container.justifyContent};
    align-items: ${e.theme.components.dataTable.TablePaginationView.Container.alignItems};
    gap: ${e.theme.components.dataTable.TablePaginationView.Container.gap};
    @media ${W.tabletAndUp} {
      justify-content: ${e.theme.components.dataTable.TablePaginationView.Container.tabletView.justifyContent};
      width: ${e.theme.components.dataTable.TablePaginationView.Container.tabletView.width};
    }
    `}
`, We = D.span`
  ${(e) => `
    font-family: ${e.theme.components.dataTable.TablePaginationView.ItemsPerPageDisplay.fontFamily};
    color: ${e.theme.components.dataTable.TablePaginationView.ItemsPerPageDisplay.color};
    font-size: ${e.theme.components.dataTable.TablePaginationView.ItemsPerPageDisplay.fontSize};
    font-weight: ${e.theme.components.dataTable.TablePaginationView.ItemsPerPageDisplay.fontWeight};
    line-height: ${e.theme.components.dataTable.TablePaginationView.ItemsPerPageDisplay.lineHeight};
    `}
`, dt = ({
  totalItems: e,
  tablePage: l,
  initialItemsPerPage: o,
  itemsPerPage: h,
  setItemsPerPage: w,
  setTablePage: p,
  showTotalItems: i = !0,
  showPerPageOption: L,
  perPageLabel: u = "per page",
  itemsLabel: b = "of items"
}) => {
  const [V, x] = U([]), [n, d] = U("");
  return O(() => {
    if (o) {
      const P = [];
      for (let y = 1; y <= 5; y++)
        P.push({
          label: `${o * y} ${u}`,
          value: `${o * y}`
        });
      x(P), d(`${h} ${u}`);
    }
  }, [h, o]), /* @__PURE__ */ S(Oe, { children: [
    (L || i) && /* @__PURE__ */ S(je, { children: [
      /* @__PURE__ */ t(
        Te,
        {
          style: { width: "160px" },
          options: V,
          onOptionSelect: (P) => {
            `${P.value} ${u}` !== n && (d(P.value), w && w(parseInt(P.value)));
          },
          selected: n
        }
      ),
      i && /* @__PURE__ */ t(We, { children: (() => {
        const P = l || 1, y = parseInt(n) || 1, _ = (P - 1) * y, j = _ + y, R = b.split(" ");
        return `${_ + 1} - ${j > e ? e : j} ${R[0]} ${e} ${R[1]}`;
      })() })
    ] }),
    /* @__PURE__ */ t(
      fe,
      {
        totalItems: e,
        page: l,
        itemsPerPage: parseInt(n) || 1,
        onPageChange: (P) => {
          l !== P && p(P);
        }
      }
    )
  ] });
}, Re = (e) => !!new RegExp(
  /^(?:([^0-9.,]{0,3})(?:(([1-9]\d{0,2}(?:,?\d{3})*)|\d+)?(?:\.\d{1,2})?)|(([1-9]\d{0,2}(?:,?\d{3})*)|\d+)?(?:\.\d{1,2})?([^0-9.,]{0,3}))$/
).test(e), st = (e) => parseFloat(e.replace(/[^0-9.-]+/g, "")), ze = D.div`
  ${(e) => `
  width: ${e.theme.components.dataTable.TableSearchView.Container.width}
  `}
`, Be = ({
  setRowValues: e,
  rowValues: l,
  searchValue: o,
  setSearchValue: h,
  searchPlaceholder: w,
  onSearch: p,
  onClear: i,
  setSearchEnabled: L
}) => {
  const [u, b] = U(""), V = !!u.length, x = Y(() => !!u.length, [V]);
  O(() => {
    L(x);
  }, [x]), O(() => {
    o && (b(o), n(o));
  }, [l, o]);
  const n = ge((d) => {
    if (d === "")
      e(l);
    else {
      const E = l.filter((P) => P.cellData.some((y) => {
        const _ = y?.textValue?.toLowerCase().includes(d.toLowerCase()) || typeof y?.description == "string" && y?.description?.toLowerCase().includes(d.toLowerCase());
        return !_ && Re(y?.textValue || "") ? y?.textValue?.toLowerCase()?.replace(/,/g, "")?.includes(d.toLowerCase()) : _;
      }));
      e(E);
    }
  }, 300);
  return /* @__PURE__ */ t(ze, { children: /* @__PURE__ */ t(
    Ce,
    {
      startAdornmentProp: { startAdornment: /* @__PURE__ */ t(ve, { size: "m" }) },
      endAdornmentProp: {
        endAdornment: /* @__PURE__ */ t(
          Pe,
          {
            size: "m",
            onClick: (d) => {
              b(""), n(""), h && h(""), i && i(d);
            }
          }
        )
      },
      placeholder: w || "Search here",
      textSize: "small",
      value: u,
      onChange: (d) => {
        b(d.target.value), n(d.target.value), h && h(d.target.value);
      },
      onKeyUp: (d) => {
        d.key === "Enter" && p && p(d, u);
      }
    }
  ) });
}, mt = K.memo(Be);
export {
  Me as C,
  N as L,
  ct as M,
  mt as T,
  rt as a,
  Ve as b,
  Fe as c,
  dt as d,
  Re as i,
  st as p
};
